export interface MediaItem {
  id: string;
  type: 'image' | 'video';
  url: string;
  thumbnail?: string;
  caption: string;
  category: string;
}

export interface FacilityCategory {
  id: string;
  name: string;
  icon: string;
  media: MediaItem[];
}

// export const facilitiesData: FacilityCategory[] = [
//     {
//         id: 'classroom',
//         name: 'Classroom',
//         icon: 'GraduationCap',
//         media: [
//             {
//                 id: 'c1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758413350815-7b06dbbfb9a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwY2xhc3Nyb29tfGVufDF8fHx8MTc2NjEzNDM5MXww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Modern Smart Classroom with Interactive Display',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1606761568499-6d2451b23c66?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwbGVjdHVyZSUyMGhhbGx8ZW58MXx8fHwxNzY2MTM0MzkxfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Lecture Hall with Tiered Seating',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1654366698665-e6d611a9aaa9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjbGFzc3Jvb20lMjBkZXNrcyUyMHN0dWRlbnRzfGVufDF8fHx8MTc2NjEzODUwMXww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Classroom Setup with Student Desks',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1758413350815-7b06dbbfb9a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwY2xhc3Nyb29tfGVufDF8fHx8MTc2NjEzNDM5MXww&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1758413350815-7b06dbbfb9a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwY2xhc3Nyb29tfGVufDF8fHx8MTc2NjEzNDM5MXww&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Virtual Tour: Interactive Learning Environment',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1719845853806-1c54b0ed37c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwcHJlc2VudGF0aW9uJTIwcm9vbXxlbnwxfHx8fDE3NjYxMzg1MDF8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Presentation-Ready Classroom',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758270704534-fd9715bffc0e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNsYXNzcm9vbSUyMHRlY2hub2xvZ3l8ZW58MXx8fHwxNzY2MTM4OTIzfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Smart Technology Integration',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c7',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758270704787-615782711641?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdHVkZW50cyUyMGNsYXNzcm9vbSUyMGRpc2N1c3Npb258ZW58MXx8fHwxNzY2MTM4OTIzfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Interactive Student Discussions',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1719845853806-1c54b0ed37c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwcHJlc2VudGF0aW9uJTIwcm9vbXxlbnwxfHx8fDE3NjYxMzg1MDF8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Presentation-Ready Classroom',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758270704534-fd9715bffc0e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNsYXNzcm9vbSUyMHRlY2hub2xvZ3l8ZW58MXx8fHwxNzY2MTM4OTIzfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Smart Technology Integration',
//                 category: 'classroom'
//             },

//             {
//                 id: 'c5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1719845853806-1c54b0ed37c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwcHJlc2VudGF0aW9uJTIwcm9vbXxlbnwxfHx8fDE3NjYxMzg1MDF8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Presentation-Ready Classroom',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758270704534-fd9715bffc0e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNsYXNzcm9vbSUyMHRlY2hub2xvZ3l8ZW58MXx8fHwxNzY2MTM4OTIzfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Smart Technology Integration',
//                 category: 'classroom'
//             },

//             {
//                 id: 'c5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1719845853806-1c54b0ed37c5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwcHJlc2VudGF0aW9uJTIwcm9vbXxlbnwxfHx8fDE3NjYxMzg1MDF8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Presentation-Ready Classroom',
//                 category: 'classroom'
//             },
//             {
//                 id: 'c6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758270704534-fd9715bffc0e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNsYXNzcm9vbSUyMHRlY2hub2xvZ3l8ZW58MXx8fHwxNzY2MTM4OTIzfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Smart Technology Integration',
//                 category: 'classroom'
//             },

//         ]
//     },
//     {
//         id: 'Computer',
//         name: 'Computer Lab',
//         icon: 'Users',
//         media: [
//             {
//                 id: 'conf1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1703355685952-03ed19f70f51?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb25mZXJlbmNlJTIwcm9vbSUyMG1vZGVybnxlbnwxfHx8fDE3NjYwNDk5Njh8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Executive Conference Room',
//                 category: 'conference'
//             },
//             {
//                 id: 'conf2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjByb29tfGVufDF8fHx8MTc2NjA1MDU2N3ww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Collaborative Meeting Space',
//                 category: 'conference'
//             },
//             {
//                 id: 'conf3',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1703355685952-03ed19f70f51?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb25mZXJlbmNlJTIwcm9vbSUyMG1vZGVybnxlbnwxfHx8fDE3NjYwNDk5Njh8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1703355685952-03ed19f70f51?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb25mZXJlbmNlJTIwcm9vbSUyMG1vZGVybnxlbnwxfHx8fDE3NjYwNDk5Njh8MA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Conference Room Facilities Walkthrough',
//                 category: 'conference'
//             },
//             {
//                 id: 'conf4',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmclMjByb29tfGVufDF8fHx8MTc2NjA1MDU2N3ww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Modern Meeting Room Setup',
//                 category: 'conference'
//             },
//             {
//                 id: 'conf5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1567176019727-21d0a58f24e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb25mZXJlbmNlJTIwdGFibGUlMjBtZWV0aW5nfGVufDF8fHx8MTc2NjEzODkyM3ww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Professional Conference Table',
//                 category: 'conference'
//             },
//             {
//                 id: 'conf6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1758691736545-5c33b6255dca?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByZXNlbnRhdGlvbiUyMHNjcmVlbnxlbnwxfHx8fDE3NjYxMzg5MjR8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Presentation Technology',
//                 category: 'conference'
//             },
//         ]
//     },
//     {
//         id: 'seminar',
//         name: 'Seminar Hall',
//         icon: 'Building2',
//         media: [
//             {
//                 id: 'sem1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1764471444363-e6dc0f9773bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzZW1pbmFyJTIwaGFsbCUyMGF1ZGl0b3JpdW18ZW58MXx8fHwxNzY2MTM4MjkwfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Grand Auditorium for Seminars',
//                 category: 'seminar'
//             },
//             {
//                 id: 'sem2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1643199032520-99230e970fb9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwYXVkaXRvcml1bSUyMHNlYXRzfGVufDF8fHx8MTc2NjEzODQ5OHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Auditorium Seating Arrangement',
//                 category: 'seminar'
//             },
//             {
//                 id: 'sem3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1606761568499-6d2451b23c66?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwbGVjdHVyZSUyMGhhbGx8ZW58MXx8fHwxNzY2MTM0MzkxfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Large Capacity Seminar Hall',
//                 category: 'seminar'
//             },
//             {
//                 id: 'sem4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1764471444363-e6dc0f9773bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzZW1pbmFyJTIwaGFsbCUyMGF1ZGl0b3JpdW18ZW58MXx8fHwxNzY2MTM4MjkwfDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1764471444363-e6dc0f9773bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzZW1pbmFyJTIwaGFsbCUyMGF1ZGl0b3JpdW18ZW58MXx8fHwxNzY2MTM4MjkwfDA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: '360° View of Seminar Hall',
//                 category: 'seminar'
//             },
//         ]
//     },
//     {
//         id: 'library',
//         name: 'Library',
//         icon: 'BookOpen',
//         media: [
//             {
//                 id: 'lib1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1684403798139-289e0f7fa5da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwbGlicmFyeXxlbnwxfHx8fDE3NjYwNDc5ODd8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Modern University Library',
//                 category: 'library'
//             },
//             {
//                 id: 'lib2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1735217802509-08c31dcb63e5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsaWJyYXJ5JTIwcmVhZGluZyUyMHJvb218ZW58MXx8fHwxNzY2MTM4NDk4fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Quiet Reading Rooms',
//                 category: 'library'
//             },
//             {
//                 id: 'lib3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1662582631700-676a217d511f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsaWJyYXJ5JTIwYm9va3MlMjBzaGVsdmVzfGVufDF8fHx8MTc2NjEzODUwMnww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Extensive Book Collection',
//                 category: 'library'
//             },
//             {
//                 id: 'lib4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1684403798139-289e0f7fa5da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwbGlicmFyeXxlbnwxfHx8fDE3NjYwNDc5ODd8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1684403798139-289e0f7fa5da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB1bml2ZXJzaXR5JTIwbGlicmFyeXxlbnwxfHx8fDE3NjYwNDc5ODd8MA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Library Tour: Study Zones & Resources',
//                 category: 'library'
//             },
//             {
//                 id: 'lib5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1735217802509-08c31dcb63e5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsaWJyYXJ5JTIwcmVhZGluZyUyMHJvb218ZW58MXx8fHwxNzY2MTM4NDk4fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Individual Study Spaces',
//                 category: 'library'
//             },
//         ]
//     },
//     {
//         id: 'labs',
//         name: 'Healthcare Labs',
//         icon: 'FlaskConical',
//         media: [
//             {
//                 id: 'lab1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Advanced Science Laboratory',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1562411053-c9ac630a5934?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVtaXN0cnklMjBsYWIlMjB1bml2ZXJzaXR5fGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Chemistry Lab with Modern Equipment',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1569653402334-2e98fbaa80ee?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY29tcHV0ZXIlMjBsYWJ8ZW58MXx8fHwxNzY2MTM4NDk4fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Computer Science Lab',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Lab Equipment & Experiments Showcase',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1562411053-c9ac630a5934?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVtaXN0cnklMjBsYWIlMjB1bml2ZXJzaXR5fGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Research-Grade Laboratory Facilities',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1614308457932-e16d85c5d053?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxiaW9sb2d5JTIwbGFiJTIwbWljcm9zY29wZXxlbnwxfHx8fDE3NjYxMzg5MjZ8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Biology Lab with Microscopes',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab7',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1761071176091-7da66403d24a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaHlzaWNzJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYxMzg5Mjd8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Physics Laboratory Equipment',
//                 category: 'labs'
//             },
//         ]
//     },
//     {
//         id: 'foodproductionlab',
//         name: 'Food Production Lab',
//         icon: 'FlaskConical',
//         media: [
//             {
//                 id: 'lab1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Advanced Science Laboratory',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1562411053-c9ac630a5934?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVtaXN0cnklMjBsYWIlMjB1bml2ZXJzaXR5fGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Chemistry Lab with Modern Equipment',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1569653402334-2e98fbaa80ee?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY29tcHV0ZXIlMjBsYWJ8ZW58MXx8fHwxNzY2MTM4NDk4fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Computer Science Lab',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1707944746620-fc0371b91906?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYwNTEzNDR8MA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Lab Equipment & Experiments Showcase',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1562411053-c9ac630a5934?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGVtaXN0cnklMjBsYWIlMjB1bml2ZXJzaXR5fGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Research-Grade Laboratory Facilities',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab6',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1614308457932-e16d85c5d053?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxiaW9sb2d5JTIwbGFiJTIwbWljcm9zY29wZXxlbnwxfHx8fDE3NjYxMzg5MjZ8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Biology Lab with Microscopes',
//                 category: 'labs'
//             },
//             {
//                 id: 'lab7',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1761071176091-7da66403d24a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaHlzaWNzJTIwbGFib3JhdG9yeSUyMGVxdWlwbWVudHxlbnwxfHx8fDE3NjYxMzg5Mjd8MA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Physics Laboratory Equipment',
//                 category: 'labs'
//             },
//         ]
//     },
//     {
//         id: 'student-spaces',
//         name: 'Student Spaces',
//         icon: 'UsersRound',
//         media: [
//             {
//                 id: 'ss1',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1766071546174-4cbd45eb0113?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdHVkZW50JTIwbG91bmdlJTIwbW9kZXJufGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Modern Student Lounge',
//                 category: 'student-spaces'
//             },
//             {
//                 id: 'ss2',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1632834380561-d1e05839a33a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZGVudHN8ZW58MXx8fHwxNzY2MDU1NDU0fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Campus Outdoor Learning Spaces',
//                 category: 'student-spaces'
//             },
//             {
//                 id: 'ss3',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1766071546174-4cbd45eb0113?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdHVkZW50JTIwbG91bmdlJTIwbW9kZXJufGVufDF8fHx8MTc2NjEzODUwMHww&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Collaborative Study Areas',
//                 category: 'student-spaces'
//             },
//             {
//                 id: 'ss4',
//                 type: 'video',
//                 url: 'https://images.unsplash.com/photo-1632834380561-d1e05839a33a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZGVudHN8ZW58MXx8fHwxNzY2MDU1NDU0fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 thumbnail: 'https://images.unsplash.com/photo-1632834380561-d1e05839a33a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZGVudHN8ZW58MXx8fHwxNzY2MDU1NDU0fDA&ixlib=rb-4.1.0&q=80&w=400',
//                 caption: 'Campus Life: Student Spaces Tour',
//                 category: 'student-spaces'
//             },
//             {
//                 id: 'ss5',
//                 type: 'image',
//                 url: 'https://images.unsplash.com/photo-1632834380561-d1e05839a33a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1bml2ZXJzaXR5JTIwY2FtcHVzJTIwc3R1ZGVudHN8ZW58MXx8fHwxNzY2MDU1NDU0fDA&ixlib=rb-4.1.0&q=80&w=1080',
//                 caption: 'Recreation & Social Spaces',
//                 category: 'student-spaces'
//             },
//         ]
//     }
// ];

export const facilitiesData: FacilityCategory[] = [
  /* ================= STUDENT SPACES ================= */
  {
    id: "student-spaces",
    name: "Student Spaces",
    icon: "UsersRound",
    media: [
      {
        id: "ss1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/student-Space/ADP_6835.jpg",
        caption: "Student Common Area",
        category: "student-spaces",
      },
      {
        id: "ss2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/student-Space/ADP_7007.jpg",
        caption: "Interactive Student Space",
        category: "student-spaces",
      },
      {
        id: "ss3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/student-Space/DSC06204.jpg",
        caption: "Student Collaboration Area",
        category: "student-spaces",
      },
      {
        id: "ss4",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/student-Space/DSC06235.jpg",
        caption: "Student Recreation Space",
        category: "student-spaces",
      },
      {
        id: "ss5",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/student-Space/Student_s+space.jpg",
        caption: "Modern Student Lounge",
        category: "student-spaces",
      },
    ],
  },

  /* ================= SEMINAR HALL ================= */
  {
    id: "seminar",
    name: "Seminar Hall",
    icon: "Building2",
    media: [
      {
        id: "sem1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Seminar+hall/ADP_8059.jpg",
        caption: "Seminar Hall Interior",
        category: "seminar",
      },
      {
        id: "sem2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Seminar+hall/ADP_7950.jpg",
        caption: "Audience Seating Area",
        category: "seminar",
      },
      {
        id: "sem3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Seminar+hall/ADP_7868.jpg",
        caption: "Fully Equipped Seminar Hall",
        category: "seminar",
      },
      {
        id: "sem4",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Seminar+hall/Seminar+Hall+(1).jpg",
        caption: "Seminal hall at MSU",
        category: "seminar",
      },
      {
        id: "sem6",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Seminar+hall/Seminar+hall+2.JPG",
        caption: "Student Lecturing at MSU",
        category: "seminar",
      },
    ],
  },

  /* ================= LIBRARY ================= */
  {
    id: "library",
    name: "Library",
    icon: "BookOpen",
    media: [
      {
        id: "lib1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Library/DSC06168.jpg",
        caption: "University Library",
        category: "library",
      },
      {
        id: "lib2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Library/Library+2.jpg",
        caption: "Reading Area",
        category: "library",
      },
      {
        id: "lib3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Library/_RAH7221+(1).jpg",
        caption: "Book Collection & Study Space",
        category: "library",
      },
      {
        id: "lib5",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Library/_RAH7208+(1).jpg",
        caption: "Book Collection & Study Space",
        category: "library",
      },
      {
        id: "lib6",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Library/_RAH7203+(1).jpg",
        caption: "Book Collection & Study Space",
        category: "library",
      },
    ],
  },

  /* ================= HEALTHCARE LAB ================= */
  {
    id: "labs",
    name: "Healthcare Lab",
    icon: "FlaskConical",
    media: [
      {
        id: "hl1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/ADP_7570.jpg",
        caption: "Healthcare Practical Lab",
        category: "labs",
      },
      {
        id: "hl2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/ADP_7609.jpg",
        caption: "Clinical Equipment Setup",
        category: "labs",
      },
      {
        id: "hl3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/healthcare.webp",
        caption: "Advanced Medical Lab",
        category: "labs",
      },
      {
        id: "hl4",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/ADP_7667.jpg",
        caption: "Hands-on Training Lab",
        category: "labs",
      },
      {
        id: "hl5",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/Healthcare+lab.jpg",
        caption: "Healthcare Laboratory Facility",
        category: "labs",
      },

      /* ===== Newly Added Images ===== */

      {
        id: "hl6",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/DSC00490+(1).jpg",
        caption: "Clinical Practice Area",
        category: "labs",
      },
      {
        id: "hl7",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/Emergency+Unit.jpg",
        caption: "Emergency Care Training Unit",
        category: "labs",
      },
      {
        id: "hl8",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/Physiotherapy+Lab.jpg",
        caption: "Physiotherapy Lab",
        category: "labs",
      },
      {
        id: "hl9",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Health-care-lab/radiology%2Bpo.jpg",
        caption: "Radiology & Imaging Lab",
        category: "labs",
      },
    ],
  }
  ,

  /* ================= FOOD PRODUCTION LAB ================= */
  {
    id: "foodproductionlab",
    name: "Food Production Lab",
    icon: "FlaskConical",
    media: [
      {
        id: "fp1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Food-Production-lab/ADP_8346.jpg",
        caption: "Food Production Training Area",
        category: "foodproductionlab",
      },
      {
        id: "fp2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Food-Production-lab/ADP_8361.jpg",
        caption: "Modern Food Lab Equipment",
        category: "foodproductionlab",
      },
      {
        id: "fp3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Food-Production-lab/ADP_8386.jpg",
        caption: "Practical Cooking Facility",
        category: "foodproductionlab",
      },
      {
        id: "fp4",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Food-Production-lab/ADP_8383+%281%29.jpg",
        caption: "Food Processing Lab",
        category: "foodproductionlab",
      },
      {
        id: "fp5",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Food-Production-lab/ADP_8402+(1).jpg",
        caption: "Food Processing Lab",
        category: "foodproductionlab",
      },
    ],
  },

  /* ================= COMPUTER LAB ================= */
  {
    id: "computer",
    name: "Computer Lab",
    icon: "Users",
    media: [
      {
        id: "cl1",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Computer-Lab/ADP_6425.jpg",
        caption: "Computer Lab Interior",
        category: "computer",
      },
      {
        id: "cl2",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Computer-Lab/ADP_6437.jpg",
        caption: "Student Workstations",
        category: "computer",
      },
      {
        id: "cl3",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Computer-Lab/ADP_6455.jpg",
        caption: "High-End Systems",
        category: "computer",
      },
      {
        id: "cl4",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Computer-Lab/ADP_6457.jpg",
        caption: "IT Training Facility",
        category: "computer",
      },
      {
        id: "cl5",
        type: "image",
        url: "https://cdn.msu.edu.in/msu-reavamp/images/Infustructure/Computer-Lab/ADP_6493.jpg",
        caption: "Modern Computer Lab",
        category: "computer",
      },
    ],
  },
];

